import { Component, OnInit, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { AuthorizationInfo } from 'src/app/shared/models/data/authInfo.model';
import { GroupForGrid, Groups } from 'src/app/shared/models/data/groups.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { CustomIcoCol } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { TeiasoftModalReturnObject } from 'src/app/shared/teiasoft-bucket/teiasoft-modal/teiasoft-modal.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit {

  columnsToShow: string[] = ['groupName'];
  columnsToHide: string[] = ['groupId','groupAuthorizations'];
  authInfo: AuthorizationInfo = new AuthorizationInfo();
  customIcoCols: CustomIcoCol[] = new Array();
  subscriptions: Subscription = new Subscription();
  buttonsList: TTButton[] = new Array();
  action: string = "";
  showModalGroup: boolean = false;
  groupsForGrid: GroupForGrid[]  = new Array();
  minWidthVw:number = 94.2;
  groupIdToEdit: number | null = null;
  isLoaded: boolean = false;

  // Filters
  openFilter: boolean = false;
  isDataFiltered: boolean = false;
  clearFilters: boolean = false;

  constructor(private teiasoftLoader: TeiasoftLoaderService, private backendService: BackendService, public globals: Globals, 
    private teiasoftModalService: TeiasoftModalService, private translate: TranslateService, private router: Router){
    this.buildButtonsList(false);
  }

  ngOnInit(): void {
   
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  
  buildButtonsList(onlyButtons: boolean) {
    this.buttonsList = new Array();
    let _item: TTButton = new TTButton();
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-plus';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "addGroup";
    _item.action = "add";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

     /* SHOW/HIDE FILTER */
     _item = new TTButton();
     _item.disabled = false;
     _item.icon = this.openFilter == false? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
     _item.id = 7;
     _item.size = "";
     _item.text = "";
     _item.tooltip = this.openFilter == false ? "showGridFilters" : "hideGridFilters";
     _item.action = this.openFilter == false ? "showFilter" : "closeFilter";
     _item.type = '';
     _item.state =  this.isDataFiltered == true ?'pressed': '';
     this.buttonsList.push(_item);
 
     /* CLEAR FILTERS */
     _item = new TTButton();
     _item.disabled = !this.openFilter ? true : false;
     _item.icon = 'fal fa-eraser';
     _item.id = 8;
     _item.size = "";
     _item.text = "";
     _item.tooltip = "clearGridFilters";
     _item.action = "clearFilter";
     _item.type = "";
     _item.state = '';
     this.buttonsList.push(_item);

    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-users';
    _item.id = 1;
    _item.size = "";
    _item.text = "manageUsers";
    _item.tooltip = "manageUsers";
    _item.action = "manageUsers";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    if (onlyButtons == false)
      this.buildCustomIconGrid();
  }
  
  buildCustomIconGrid() {
    this.customIcoCols = new Array();
    let _item: CustomIcoCol = new CustomIcoCol();
    _item.action = 'deleteGroup';
    _item.icon = 'fal fa-trash-alt';
    _item.label ="deleteGroup";
    this.customIcoCols.push(_item);

    _item = new CustomIcoCol();
    _item.action = "editGroup"; 
    _item.icon = 'fal fa-pencil-alt';
    _item.label = "editGroup";
    this.customIcoCols.push(_item);

    this.getAuthorizationsInfo();
  }

  getAuthorizationsInfo() {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getAuthorizationsInfo().subscribe(res => {
      this.authInfo = new AuthorizationInfo();
      this.authInfo = res;
      this.getGroups();
    }));
  }

  getGroups(){
    this.subscriptions.add(this.backendService.getGroups(null).subscribe(res => {
      this.groupsForGrid = new Array();
      for (var x=0; x < res.groups!.length; x++){
        let _item: GroupForGrid = new GroupForGrid();
        _item.groupId = res.groups![x].groupId!;
        _item.groupName = res.groups![x].groupName!;
        _item.groupAuthorizations = res.groups![x].groupAuthorizations?.map(m => m.authorizations).join("; ");
        this.groupsForGrid.push(_item);
        this.groupsForGrid = this.groupsForGrid.sort((a,b) => (a.groupName! > b.groupName!) ? 1 : ((b.groupName! > a.groupName! ? -1 : 0)));
      }
      setTimeout(() => {
        this.isLoaded = true;
        this.teiasoftLoader.stop();
      }, 250);
    }));
  }

  deleteGroup(groupId: number){
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.deleteGroup(groupId).subscribe(res => {
      this.getGroups();
    }));
  }

  /* EVENTS */
  customIconClick(evt:any){
    const { action: _action, row: _obj } = parseGridActionEvent(evt);
    if (_action == 'deleteGroup'){
      let _param: number = _obj["groupId"];
      let _gName: string = this.groupsForGrid.filter(x => x.groupId == _param)[0].groupName!;
      let _message: string = this.translate.instant("users.confirmDeleteGroup").replace("{0}", _gName);
      this.teiasoftModalService.show('confirm', this.translate.instant("users.deleteGroup"), _message, _param, 'confirmDeleteGroup');
    } else {
      this.action = 'edit';
      this.groupIdToEdit = _obj["groupId"];
      this.showModalGroup = true;
    }
  }

  onBtnToolbarClick(btn:TTButton){
    if (btn.action == 'add') {
      this.action = 'create';
      this.groupIdToEdit = null;
      this.showModalGroup = true;
    }

    if (btn.action == 'manageUsers'){
      this.router.navigate(["/users"]);
    }

    if (btn.action == 'showFilter'){
      this.openFilter = true;
      this.buildButtonsList(true);
    }

    if (btn.action == 'closeFilter'){
      this.openFilter = false;
      this.buildButtonsList(true);
    }

    if (btn.action == 'clearFilter'){
      this.clearFilters = true;
      setTimeout(() => this.clearFilters = false, 250);
    }
  }

  onConfirmModal(evt:TeiasoftModalReturnObject) {
    if (evt.closeFlag == 'confirmDeleteGroup'){
      this.deleteGroup(evt.parameter!);
    }
  }

  closeModalGroup(evt:string){
    if (evt == 'reload'){
      this.teiasoftLoader.start();
      this.getGroups();
    }
    this.action = '';
    this.groupIdToEdit = null;
    this.showModalGroup = false;
  }

  imFiltering(evt: boolean){
    this.isDataFiltered = evt;
    this.buildButtonsList(true);
  }
}
